import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../hooks/redux'

import LoadingSpinner from '../../../components/atoms/LoadingSpinner'
import ArticleView from './ArticleView'

import { fetchArticles, returnToRoot } from '../../../slices/article'
import useStyles from './styles'

const DocumentPanel = () => {
  const dispatch = useAppDispatch()

  const { root, loaded } = useAppSelector(state => state.article)

  const classes = useStyles()

  React.useEffect(() => {
    if (!loaded) {
      dispatch(fetchArticles())
    }
  }, [loaded, dispatch])

  const totalCount = React.useMemo(() => {
    if (!loaded || !root?.items) {
      return 0
    }

    let count = 0
    root.items.forEach(item => {
      if (item.type === 'article') {
        count += 1
      } else {
        count += item.total_items
      }
    })

    return count
  }, [loaded, root])

  const handleGoToRootClick = React.useCallback(() => {
    dispatch(returnToRoot())
  }, [dispatch])

  if (!loaded) {
    return (
      <div style={{ position: 'relative' }}>
        <LoadingSpinner />
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <div onClick={handleGoToRootClick} className={classes.header}>
        <div className={classes.border} />

        <div className={classes.title}>Folder / Article</div>

        <div className={classes.count}>{totalCount}</div>
      </div>

      <div className={classes.articles}>
        <ArticleView items={root?.items} />
      </div>
    </div>
  )
}

export default DocumentPanel
